import React from "react";

import AppWrapper from "../../components/cm/AppWrapper";
import MyAccount from "../../components/cm/Dashboard/FullPages/MyAccount";
import SideBarMain from "../../components/cm/SideBarMain";

import KPIReport from "./KPIReports";

export default () => {
  return (
    <AppWrapper.WithSidebar sidebar={<SideBarMain />}>
      <MyAccount>
        <KPIReport />
      </MyAccount>
    </AppWrapper.WithSidebar>
  );
};
